import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flightBookingRoutes } from '../../../../utils/consts';
import React, { Component } from 'react';
import { withRouter } from '~HOC';
import { clearLocalStorage } from '../../../../utils/utility';
import { DurationIcon } from '~svg';
import { Modal } from '../../../common';

class SearchTimeout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTimeoutModal: false,
    };
  }
  componentDidMount() {
    this.setState({ showTimeoutModal: true });
  }
  searchAgain = () => {
    this.props.searchAgain();
  };

  startAgain = () => {
    this.setState({ showTimeoutModal: false });
    sessionStorage.removeItem('selectedAirport');
    clearLocalStorage();
    this.props.navigate(flightBookingRoutes.selectCity);
  };
  render() {
    return (
      <Modal
        isOpen={this.state.showTimeoutModal}
        onClose={() => this.setState({ showTimeoutModal: false })}
        modalWidth="col-12 col-xl-6 col-sm-8"
      >
        <div className="d-flex w-100 ">
          <div className="w-100" style={{ top: '15%' }}>
            <div
              className=" d-flex justify-content-center align-items-center"
              style={{
                zIndex: 1000,
              }}
            >
              <div
                className=" w-100"
                style={{
                  backgroundColor: 'rgba(255, 255, 255)',
                  alignItem: 'center',
                  margin: 'auto',
                }}
              >
                <div className=" d-flex  flex-column justify-content-center ">
                  <div className="d-flex w-100 align-items-start pb-2 justify-content-center ">
                    <div
                      className={`font-huge d-flex justify-content-center w-100`}
                    >
                      <DurationIcon color="#85cd95" size={36} />
                    </div>
                  </div>

                  <div
                    className={`d-flex text-dark font-xlarge font-weight-bold justify-content-center   text-center`}
                  >
                    <FormattedMessage
                      id={this.props.titleMessage}
                      defaultMessage={this.props.titleMessage}
                    />
                  </div>
                  <div
                    className={`d-flex text-center text-dark  font-small justify-content-center pt-2 text-third font-weight-bold  `}
                  >
                    <FormattedMessage
                      id={this.props.errorMessage}
                      defaultMessage={this.props.errorMessage}
                    />
                  </div>
                  {this.props.message ? (
                    <div
                      className={`d-flex text-center pt-2 text-dark  font-small justify-content-center  text-third font-weight-bold `}
                    >
                      <FormattedMessage
                        id={this.props.message}
                        defaultMessage={this.props.message}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="d-flex w-100 bg-primary p-0 m-0 mt-4">
                  <div
                    className={`d-flex w-100 justify-content-center py-0 m-0 px-0  `}
                  >
                    <div
                      onClick={() => this.searchAgain()}
                      className={`py-2 w-50 text-center  font-weight-bold text-white border-1 border-primary bg-primary-light h-100 cursor-pointer
                    `}
                    >
                      <FormattedMessage
                        id="booking.searchagian"
                        defaultMessage="booking.searchagian"
                      />
                    </div>
                    <div
                      onClick={() => this.startAgain()}
                      className={`py-2 text-center font-weight-bold text-white border-1 bg-third border-third h-100 w-50 cursor-pointer `}
                    >
                      <FormattedMessage
                        id="booking.startagain"
                        defaultMessage="booking.startagain"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
function mapStateToProps(state) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps)(withRouter(SearchTimeout)));
